import React,{useState,useEffect} from 'react';
import {motion,AnimatePresence} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from './common/SafeIcon';
import Header from './components/Header';
import Hero from './components/Hero';
import PainSection from './components/PainSection';
import AboutEbook from './components/AboutEbook';
import BonusSection from './components/BonusSection';
import CostOfInaction from './components/CostOfInaction';
import WhoItsFor from './components/WhoItsFor';
import Testimonials from './components/Testimonials';
import HowItWorks from './components/HowItWorks';
import OfferRecap from './components/OfferRecap';
import FAQ from './components/FAQ';
import FinalCTA from './components/FinalCTA';
import Footer from './components/Footer';
import ExitPopup from './components/ExitPopup';
import BumpOffer from './components/BumpOffer';
import ConfirmationPage from './components/ConfirmationPage';
import PaymentProcessor from './components/PaymentProcessor';
import './App.css';

const {FiStar,FiClock,FiCheck,FiGift,FiTarget,FiTrendingUp,FiUsers,FiShield,FiZap,FiHeart,FiX}=FiIcons;

function App() {
  const [showExitPopup,setShowExitPopup]=useState(false);
  const [showBumpOffer,setShowBumpOffer]=useState(false);
  const [showConfirmation,setShowConfirmation]=useState(false);
  const [showPaymentModal,setShowPaymentModal]=useState(false);
  const [customerData,setCustomerData]=useState(null);
  const [hasBump,setHasBump]=useState(false);
  const [timeLeft,setTimeLeft]=useState(15 * 60);// 15 minutes in seconds

  useEffect(()=> {
    const timer=setInterval(()=> {
      setTimeLeft(prev=> {
        if (prev <=0) {
          clearInterval(timer);
          return 0;
        }
        return prev - 1;
      });
    },1000);
    return ()=> clearInterval(timer);
  },[]);

  useEffect(()=> {
    const handleMouseLeave=(e)=> {
      if (e.clientY <=0) {
        setShowExitPopup(true);
      }
    };
    document.addEventListener('mouseleave',handleMouseLeave);
    return ()=> document.removeEventListener('mouseleave',handleMouseLeave);
  },[]);

  const formatTime=(seconds)=> {
    const mins=Math.floor(seconds / 60);
    const secs=seconds % 60;
    return `${mins.toString().padStart(2,'0')}:${secs.toString().padStart(2,'0')}`;
  };

  const openCheckoutPopup=()=> {
    setShowPaymentModal(true);
  };

  const closeCheckoutPopup=()=> {
    setShowPaymentModal(false);
  };

  const handlePaymentSuccess=(data)=> {
    setCustomerData(data);
    setShowPaymentModal(false);
    setShowBumpOffer(true);
  };

  const handleBumpAccept=()=> {
    setHasBump(true);
    setShowBumpOffer(false);
    setShowConfirmation(true);
  };

  const handleBumpDecline=()=> {
    setShowBumpOffer(false);
    setShowConfirmation(true);
  };

  if (showConfirmation) {
    return <ConfirmationPage customerData={customerData} hasBump={hasBump} />;
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 to-orange-50">
      <div className="sparkles-bg"></div>
      <Header timeLeft={timeLeft} openCheckoutPopup={openCheckoutPopup} />
      <main>
        <Hero timeLeft={timeLeft} formatTime={formatTime} openCheckoutPopup={openCheckoutPopup} />
        <PainSection openCheckoutPopup={openCheckoutPopup} />
        <AboutEbook openCheckoutPopup={openCheckoutPopup} />
        <BonusSection timeLeft={timeLeft} openCheckoutPopup={openCheckoutPopup} />
        <CostOfInaction openCheckoutPopup={openCheckoutPopup} />
        <WhoItsFor />
        <Testimonials />
        <HowItWorks openCheckoutPopup={openCheckoutPopup} />
        <OfferRecap timeLeft={timeLeft} formatTime={formatTime} onPaymentSuccess={handlePaymentSuccess} />
        <FAQ />
        <FinalCTA timeLeft={timeLeft} formatTime={formatTime} openCheckoutPopup={openCheckoutPopup} />
      </main>
      <Footer />
      <ExitPopup show={showExitPopup} onClose={()=> setShowExitPopup(false)} />
      
      <AnimatePresence>
        {showBumpOffer && (
          <BumpOffer customerData={customerData} onAccept={handleBumpAccept} onDecline={handleBumpDecline} />
        )}
      </AnimatePresence>

      <AnimatePresence>
        {showPaymentModal && (
          <motion.div 
            className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4"
            initial={{opacity: 0}}
            animate={{opacity: 1}}
            exit={{opacity: 0}}
            onClick={closeCheckoutPopup}
          >
            <motion.div 
              className="bg-white rounded-3xl max-w-2xl w-full max-h-[90vh] overflow-y-auto relative"
              initial={{scale: 0.9, opacity: 0}}
              animate={{scale: 1, opacity: 1}}
              exit={{scale: 0.9, opacity: 0}}
              onClick={(e)=> e.stopPropagation()}
            >
              <button 
                onClick={closeCheckoutPopup}
                className="absolute top-4 right-4 p-2 hover:bg-gray-100 rounded-full z-10"
              >
                <SafeIcon icon={FiX} className="w-6 h-6 text-gray-600" />
              </button>
              
              <div className="p-8">
                <PaymentProcessor 
                  timeLeft={timeLeft}
                  onSuccess={handlePaymentSuccess}
                  onClose={closeCheckoutPopup}
                />
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

export default App;